module.exports = __webpack_public_path__ + "static/media/imix-tab3.d9578d18.png";